if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false
      
      // Calculate progress percentage (0-100)
      let progressPercentage = Math.min(100, Math.round((cartTotal / freeShippingThreshold) * 100));
      const icon = this.parentElement.querySelector('#shipping-icon');

        if (icon) {
          const maxPercentage = Math.min(progressPercentage, 95);

          icon.style.left = maxPercentage + '%';
          icon.style.transform = 'translateX(-50%)';
        }

      if ( freeShippingRemaining < 0 ) {
        const remainingCents = Math.abs(freeShippingRemaining);
        shippingMessage = (window.KROWN.settings.locales.shipping_notice_remaining_to_free).replace('{{ remaining_amount }}', this._formatMoney(remainingCents, KROWN.settings.shop_money_format));
        // "Falta" no singular só quando o valor restante for exatamente R$ 1,00 (100 centavos).
        // Em qualquer outro valor, o correto em português é "Faltam".
        if ( remainingCents !== 100 ) {
          shippingMessage = shippingMessage.replace(/^Falta\b/, 'Faltam');
        }

      } else {
        shippingMessage = (window.KROWN.settings.locales.shipping_notice_eligible_for_free);
        shippingSuccess = true;
        progressPercentage = 100; // Ensure the progress bar is full when eligible
      }

      // Create progress bar HTML
      const progressBar = `
        <div class="shipping-progress-container" style="width: 100%; background-color: #D9D9D9; border-radius: 10px; margin: 8px 0; overflow: hidden;">
          <div class="shipping-progress-bar" style="height: 5px; width: ${progressPercentage}%; background: ${shippingSuccess ? '#FF228B' : 'repeating-linear-gradient(-45deg,#FF228B,#FF228B 5px,#cc1c70 5px,#cc1c70 10px)'}; transition: width 0.3s ease;"></div>
        </div>

      `;
      const infoMsg = `
        <div style="    height: 19px;">
          <span style="font-size: 10px;">*exceto poltrona e carrinho tech</span>
        </div>

      `;

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
            ${infoMsg}
            ${progressBar}
          </div>`;
      } else {
        this.innerHTML = `
          <div class="progress-msg">
            ${shippingMessage}
            ${infoMsg}
            ${progressBar}
          </div>
        `;
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
